import { Component, EventEmitter, inject, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { DataService } from '@zero/shared/util-web-app-services';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'home-ad-agree-note',
  imports: [TranslocoPipe, ButtonComponent],
  templateUrl: './ad-agree-note.component.html',
})
export class AdAgreeNoteComponent {
  readonly #dataService = inject(DataService);

  @Output() public hideNote = new EventEmitter<void>();

  public async adAgreed(): Promise<void> {
    await firstValueFrom(this.#dataService.toggleAdAgree(true));
    this.hideNote.emit();
  }

  public showAdAgreeNoteLater(): void {
    this.#dataService.postponeAdAgreeDecision();
    this.hideNote.emit();
  }

  public async adAgreeDeclined(): Promise<void> {
    await firstValueFrom(this.#dataService.toggleAdAgree(false));
    this.hideNote.emit();
  }
}
